import { render } from "./HelpDialog.vue?vue&type=template&id=dc5ca57e&scoped=true"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"

import "./HelpDialog.vue?vue&type=style&index=0&id=dc5ca57e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5ca57e"]])

export default __exports__